var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRemoveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 4.55566H16",
    stroke: "#FF6666",
    strokeWidth: 1.26562,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.875 4.55566V14.3334C2.875 15.8062 4.1342 17.0001 5.6875 17.0001H11.3125C12.8658 17.0001 14.125 15.8062 14.125 14.3334V4.55566",
    stroke: "#FF6666",
    strokeWidth: 1.26562,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.6875 2.77778C5.6875 1.79594 6.52697 1 7.5625 1H9.4375C10.4731 1 11.3125 1.79594 11.3125 2.77778V4.55556H5.6875V2.77778Z",
    stroke: "#FF6666",
    strokeWidth: 1.26562,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoveIcon);
export default __webpack_public_path__ + "static/media/removeIcon.d7c8c2e93a261b24a26bcc71ddabdec5.svg";
export { ForwardRef as ReactComponent };